<template>
  <div>
    <div class="yotpo-widget-instance" :data-yotpo-instance-id="config.public.yotpoSeoInstanceId"/>
  </div>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp()
const config = nuxtApp.$config
useHead({
  title: 'Thorne Product Reviews | Throne',
  meta: [{name: 'description', content: "Discover authentic product reviews for Thorne's science-backed wellness solutions. Explore customer insights and experiences to find the perfect products for your health journey."}],
  script: [ {async: true, src: `https://cdn-widgetsrepository.yotpo.com/v1/loader/${config.public.yotpoStoreId}`}]
})
</script>
